import memoize from 'moize';

export const MemoizedComponent: any = (component: any): any =>
  memoize.react(component, { isDeepEqual: true });

export default MemoizedComponent;
